export const colors = {
  primary: "#EB5139",
  primaryHover: "#d4432d",
  primaryLight: "#f97b65",
  surface: "#1a1a1a",
  surfaceElevated: "#242424",
  surfaceBorder: "#2e2e2e",
  text: "#ffffff",
  textMuted: "rgba(255,255,255,0.55)",
  textInverse: "#1a1a1a",
  success: "#22c55e",
  error: "#ef4444",
  warning: "#f59e0b",
  info: "#3b82f6",
} as const;

export const spacing = {
  xs: "0.25rem",
  sm: "0.5rem",
  md: "0.75rem",
  lg: "1rem",
  xl: "1.5rem",
  "2xl": "2rem",
  "3xl": "3rem",
} as const;

export const radius = {
  sm: "6px",
  md: "10px",
  lg: "14px",
  full: "9999px",
} as const;

export const typography = {
  fontFamily: "'Satoshi', system-ui, -apple-system, sans-serif",
  fontMono: "'JetBrains Mono', 'Fira Code', monospace",
  size: {
    xs: "0.75rem",
    sm: "0.875rem",
    base: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
    "2xl": "1.5rem",
    "3xl": "1.875rem",
    "4xl": "2.25rem",
  },
  weight: {
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
} as const;

export const shadows = {
  sm: "0 1px 3px rgba(0,0,0,0.3)",
  md: "0 4px 12px rgba(0,0,0,0.4)",
  lg: "0 8px 24px rgba(0,0,0,0.5)",
  glow: `0 0 20px rgba(235,81,57,0.35)`,
} as const;

export const transitions = {
  fast: "0.15s ease",
  base: "0.25s ease",
  slow: "0.4s ease",
} as const;
